document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.hero-banner').forEach(function (banner) {
    var slides = Array.prototype.slice.call(banner.querySelectorAll('.hero-banner__slide'));
    var dots = Array.prototype.slice.call(banner.querySelectorAll('.hero-banner__dot'));
    var prevBtn = banner.querySelector('.hero-banner__arrow--prev');
    var nextBtn = banner.querySelector('.hero-banner__arrow--next');
    if (slides.length <= 1) return;

    var current = 0;
    var autoplay = banner.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(banner.getAttribute('data-speed'), 10) || 6000;
    var timer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      if (!autoplay) return;
      stopAutoplay();
      timer = setInterval(next, speed);
    }
    function stopAutoplay() {
      if (timer) clearInterval(timer);
    }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); startAutoplay(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); startAutoplay(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); startAutoplay(); });
    });

    banner.addEventListener('mouseenter', stopAutoplay);
    banner.addEventListener('mouseleave', startAutoplay);

    startAutoplay();
  });
});